import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { FormattedPlural } from 'react-intl';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import { statusColours } from '../../constants/ColourConstants';
import SkillIcon from 'material-ui/svg-icons/social/public';

import SkillChip from '../Skill/SkillChip';


const MySkillSegment = ({skills}) => (
    <Card className="cent-card ">
        <CardHeader
            title={<Link to="/dashboard/mytraining/skills" >My Skills</Link>}
            subtitle={(<span>{skills.length} <FormattedPlural value={skills.length} one='skill' other='skills'/></span>)}
            avatar={<Link to="/dashboard/mytraining/skills" ><SkillIcon color={statusColours.default}/></Link>}
        />
        <CardText className="cent-card-chips">
            {skills.map((skill) => {
                skill.name = skill.skillName;
                skill.id   = skill.skillId;
                return (<SkillChip skill={skill} key={skill.id} actions={null} />)})
            }
        </CardText>
    </Card>
);

MySkillSegment.propTypes = {
    skills: PropTypes.arrayOf(PropTypes.object)
};

export default MySkillSegment;
